import React, {useEffect} from 'react';
import '../App.css';
import {ZendeskData} from "../reportConfigs/zendeskReports";
import SearchBar from "./SearchBar";
import {useLocation, useHistory} from "react-router-dom";

export default function Zendesk() {
    const params = useLocation();
    const pathParams = params?.pathname.split('/');

    // URL Path Params
    const type = pathParams[1];


    return (
        <>
            <div className='content'>
                <SearchBar data={ZendeskData} divider={type.toUpperCase()} finalReportIds={ZendeskData}/>
            </div>
        </>
    );
}
